import { isNull, isObject, isUndefined } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_ERASMUS_COORDINATOR } from '../utils/constants/roles.js';

function useIsUserErasmusKoordinator() {
  const user = useSelector((state) => state.auth.user);

  const isErasmusKoordinator = useMemo(() => {
    // if user is not valid object, return false
    if (!isObject(user) || isNull(user) || isUndefined(user)) {
      return false;
    }

    // check user's array of roles
    return user.roles.some((role) => role.name === ROLE_ERASMUS_COORDINATOR);
  }, [user]);

  return isErasmusKoordinator;
}

export default useIsUserErasmusKoordinator;
